// extracted by mini-css-extract-plugin
export default {"post":"PostCard_post__nyv9V","capa":"PostCard_capa__E1qIY","titulo":"PostCard_titulo__mnyhN","botaoLer":"PostCard_botaoLer__3yK4n"};